import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ThermometerIcon, AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#1e293b] text-white py-20 md:py-32" data-id="element-130">
      <div className="max-w-5xl mx-auto px-6" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-132">
          <div className="flex items-center gap-3 mb-6" data-id="element-133">
            <ThermometerIcon className="w-8 h-8 text-[#d4a853]" data-id="element-134" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white" data-id="element-135">
              El Problema Real
            </h2>
          </div>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-136">
            <p data-id="element-137">
              Para las mujeres de más de 45 años, el insomnio no es un problema
              de "estrés".{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-138">
                Es un desajuste térmico.
              </span>
            </p>

            <p data-id="element-139">
              Con el descenso de estrógenos, tu termostato interno se vuelve
              hipersensible.
            </p>

            <div className="bg-[#0f172a] border-l-4 border-[#d4a853] p-6 rounded-r-lg" data-id="element-140">
              <p className="text-white font-medium" data-id="element-141">
                Un aumento de solo medio grado en tu temperatura corporal hace
                que tu cerebro entre en "modo emergencia".
              </p>
            </div>

            <p data-id="element-142">
              Por eso te despiertas alerta, empapada en sudor o con la mente
              acelerada. No es falta de sueño, es un{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-143">
                exceso de calor biológico y cortisol
              </span>{' '}
              que no te deja descansar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}